import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalExpiredSession extends HTMLElement {
  get html() {
    return /*html*/`
      <div class="panel-content">
        <as-text dict-key="apps.general.expired-session.title" class="modal-title">Session Expired</as-text>
        <as-text class="modal-desc" id="desc-text">Your computer was asleep and your session has expired. Would you like to restore your progress?</as-text>
        <as-text class="modal-desc" id="save-date" style="margin-top: 1rem; opacity: 0.8;"></as-text>
        <div class="row option-buttons">
          <as-text-button name="discard-expired-session">Start New</as-text-button>
          <as-text-button name="restore-expired-session" variant="primary">Restore</as-text-button>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
  }

  setDate(date: Date) {
    const el = this.shadowRoot?.querySelector('#save-date');
    if (el) {
      el.textContent = `There is an autosave file created on: ${date.toLocaleString()}`;
    }
  }
}

if (!customElements.get('as-modal-expired-session')) {
  customElements.define('as-modal-expired-session', AsModalExpiredSession);
} else {
  console.warn('as-modal-expired-session already defined');
}
